import { render, staticRenderFns } from "./BrandCategories.vue?vue&type=template&id=23bbc3b1&scoped=true"
import script from "./BrandCategories.vue?vue&type=script&lang=js"
export * from "./BrandCategories.vue?vue&type=script&lang=js"
import style0 from "./BrandCategories.vue?vue&type=style&index=0&id=23bbc3b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bbc3b1",
  null
  
)

export default component.exports